// Configuración de URLs de la API
export const getBaseUrl = (
  hostname = (typeof window !== 'undefined' ? window.location.hostname : ''),
  envBaseUrl = process.env.REACT_APP_API_BASE_URL
) => {
  const isLocalHost = ['localhost', '127.0.0.1'].includes(hostname);
  const isTunnelHost = typeof hostname === 'string' && hostname.endsWith('.trycloudflare.com');

  // Si se ejecuta en localhost, siempre usar la API local de XAMPP
  if (isLocalHost) {
    return 'http://localhost/diegoncurso/api';
  }

  // Build servido vía túnel Cloudflare como respaldo local (ver DEPLOY_PUBLIC_HTML.txt)
  if (isTunnelHost) {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    return `${origin}/concurso-local/api`;
  }

  // En producción, priorizar variable de entorno y luego ruta del dominio
  return envBaseUrl || 'https://www.diegoncurso.es/api';
};

export const API_BASE_URL = getBaseUrl();

// Función para manejar errores de red y otros errores comunes
export const handleApiError = (error) => {
  if (error && error.response) {
    // El servidor respondió con un código de estado fuera del rango 2xx
    console.error('Error de respuesta:', error.response.status, error.response.data);
    return error.response.data?.message || 'Error en la respuesta del servidor';
  } else if (error && error.request) {
    // La petición fue hecha pero no hubo respuesta
    console.error('Error de red:', error.request);
    return 'Error de conexión con el servidor';
  } else if (error && error.message) {
    // Algo sucedió al preparar la petición
    console.error('Error:', error.message);
    return 'Error en la solicitud';
  } else {
    // Otro tipo de error
    console.error('Error desconocido:', error);
    return 'Error desconocido';
 }
};

// Función para limpiar headers problemáticos
export const sanitizeHeaders = (headers) => {
  // Eliminar headers que causan advertencias en navegadores modernos
  const sanitized = { ...headers };
  
  // Headers de políticas obsoletas o experimentales que causan advertencias
  const problematicHeaders = [
    'browsing-topics',
    'run-ad-auction', 
    'join-ad-interest-group',
    'private-state-token-redemption',
    'private-state-token-issuance',
    'private-aggregation',
    'attribution-reporting'
  ];
  
  // Filtrar headers que contienen estas características problemáticas
  Object.keys(sanitized).forEach(key => {
    if (typeof sanitized[key] === 'string') {
      problematicHeaders.forEach(header => {
        if (sanitized[key].toLowerCase().includes(header.toLowerCase())) {
          sanitized[key] = sanitized[key].replace(new RegExp(header, 'gi'), '');
        }
      });
    }
  });
  
  return sanitized;
};
